import { render, staticRenderFns } from "./AvatarPlaceholder.vue?vue&type=template&id=1579f1fd"
import script from "./AvatarPlaceholder.vue?vue&type=script&lang=js"
export * from "./AvatarPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports